import { VStack } from '@chakra-ui/react';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const AboutHoverInvestorsMobile: React.FC = () => (
  <VStack
    display={{ base: 'flex', tablet: 'none' }}
    spacing={700}
    alignItems="center"
  >
    <StaticImage
      quality={100}
      placeholder="blurred"
      width={192}
      height={45}
      src="../../../assets/images/travelers_vector_logo.png"
      alt="investors travelers"
    />
    <StaticImage
      quality={100}
      placeholder="blurred"
      width={130}
      height={47}
      src="../../../assets/images/menlo_ventures_logo.png"
      alt="investors menlo"
    />
    <StaticImage
      quality={100}
      placeholder="blurred"
      width={54}
      height={33}
      src="../../../assets/images/vc_logos.png"
      alt="vc"
    />
    <StaticImage
      quality={100}
      placeholder="blurred"
      width={260}
      height={22}
      src="../../../assets/images/state_farm_ventures_logo.png"
      alt="state farm"
    />
    <StaticImage
      quality={100}
      placeholder="blurred"
      width={160}
      height={60}
      src="../../../assets/images/nationwide_seeklogo.png"
      alt="nation wide"
    />
  </VStack>
);

export default AboutHoverInvestorsMobile;
